var pre = '/canteen/';
export default {
  path: '/canteen',
  title: '食堂管理',
  header: 'home',
  icon: 'md-restaurant',
  auth: ['canteen-manage'],
  children: [{
    path: "".concat(pre, "dish"),
    icon: 'ios-list',
    title: '菜品管理',
    subtitle: '菜品库与上下架',
    auth: ['canteen-dish']
  }, {
    path: "".concat(pre, "menu"),
    icon: 'ios-calendar',
    title: '菜单管理',
    subtitle: '周循环与临时替补',
    auth: ['canteen-menu']
  }, {
    path: "".concat(pre, "price"),
    icon: 'logo-yen',
    title: '计价设置',
    subtitle: '三类菜品单价',
    auth: ['canteen-price']
  }, {
    path: "".concat(pre, "front"),
    icon: 'ios-desktop',
    title: '食堂前台',
    subtitle: '当日菜单展示',
    auth: ['canteen-front']
  }, {
    path: "".concat(pre, "weigh"),
    icon: 'ios-calculator',
    title: '称重计价',
    subtitle: '称重收银与推送账单',
    auth: ['canteen-weigh']
  }, {
    path: "".concat(pre, "bills"),
    icon: 'ios-document',
    title: '订单账单',
    subtitle: '称重账单查询',
    auth: ['canteen-bill']
  }, {
    path: "".concat(pre, "recharge"),
    icon: 'ios-card',
    title: '余额充值',
    subtitle: '档位与手动充值',
    auth: ['canteen-recharge']
  }, {
    path: "".concat(pre, "coupon"),
    icon: 'ios-pricetag',
    title: '折扣券',
    subtitle: '模板与启停',
    auth: ['canteen-coupon']
  }]
};